import { render } from "./App.vue?vue&type=template&id=6e67b426"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6e67b426&lang=css"

import exportComponent from "/codebuild/output/src3987420887/src/bt-website-2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__